import { Tag } from "antd"
import { getIcon } from "../../helpers/getIcon"
import { tagsBageStatus } from "../../helpers/tagsBage"
import { getTableRowClassName } from "../../helpers/getRowClassName"
import { CustomerStatuses, verifyslipStatuses, withdrawStatuses } from "../../Data/StatusData"
import { stylesFooter } from "./style.main"




export const FooterDashboard = ({ t }) => {
    return (<div className="fs-12 fs-sm-11 " style={{ marginTop: 16 }}>
        <ul className="mb-3" style={{ listStyle: '', padding: "0 10px" }}>
            <strong>{t("note")}</strong>:{" "}
            <li style={{ color: "#888" }}>{t("The system will update data every 1-2 minutes.")}</li>
            <li style={{ color: "#888" }}>{t("[บัญชีถอน] วงเงินที่ใช้ได้วันนี้ จะคำนวณ จาก จำนวนเงินที่ถอนวันนี้ - limit_Left = วงเงินที่ใช้ได้วันนี้")}</li>
            <li style={{ color: "#888" }}>{t("[บัญชีถอน] 'วงเงินที่ใช้ได้วันนี้' จะแสดงเมื่อกดอัพเดทยอดและมีข้อมูล limit_Left แสดงในหน้าแดชบอร์ด")}</li>
            <li style={{ color: "#888" }}>{t("[บัญชีถอน] หากข้อมูล 'วงเงินที่ใช้ได้วันนี้' ไม่แสดง ให้ไปที่เมนู บัญชีธนาคาร => แก้ไข (สำหรับผู้ที่ได้รับสิทธ์ให้แก้ไขได้) => กรอกข้อมูล วงเงินที่แสดงในแอพ *วงเงินต้องเป็นจำนวนจริงที่แสดงในแอพหรือเว็ปไซต์")}</li>
            <li style={{ color: "#888" }}>{t("ฝาก/ถอนขั้นต่ำสามารถตั้งค่าได้ที่เมนูจัดการร้านค้า")}</li>
        </ul>
    </div>)
}
export const FooterBankAccount = ({ t }) => {
    return (<div className="fs-12 fs-sm-11 mb-3" style={{ marginTop: 16, marginLeft: 10 }}>
        <ul className="mb-3" style={{ listStyle: '', padding: "0 10px" }}>
            <strong>{t("note")}</strong>:{" "}
            <li style={{ color: "#888" }}>
                {t("The system will update data every 1.30 minutes.")}
            </li>
            <li style={{ color: "#888" }}>
                {t("kbiz_qr_instruction")}
            </li>
        </ul>
    </div>)
}

export const FooterVerifyCustomer = ({ t }) => {
    return (<div className="fs-12 fs-sm-11 mb-3" style={{ marginTop: 16, marginLeft: 10 }}>
        <ul className="mb-3" style={{ listStyle: '', padding: "0 10px" }}>
            <strong>{t("note")}</strong>:{" "}
            <li style={{ color: "#888" }}>
                {t("CacheCleared_NOTE")}
            </li>
        </ul>
    </div>)
}

export const FooterDeposit = ({ t }) => {
    return (<div className="fs-12 fs-sm-11 mb-3" style={{ marginTop: 16, marginLeft: 10 }}>
        <ul className="mb-3" style={{ listStyle: '', padding: "0 10px" }}>
            <strong>{t("note")}</strong>:{" "}
            <li style={{ color: "#888" }}>
                {t("The system will update data every 1.30 minutes.")}
            </li>
        </ul>
    </div>)
}


export const FooterWithdraw = ({ t }) => {
    return (
        <div className="fs-12 fs-sm-11 mb-3" style={stylesFooter.container}>
            <ul style={stylesFooter.listWrapper}>
                <li style={{ marginBottom: 4 }}>
                    <strong>{t("note")}</strong>:
                </li>
                <li className="mb-2" style={{ color: "#676666", fontSize: 12 }}>
                    *{t("footer_refund")}
                </li>
                <li className="mb-2" style={{ color: "#676666", fontWeight: 'bold', fontSize: 12 }}>
                    {t("status_and_description")}
                </li>

                {/* วนลูปเพื่อแสดงผล Tag ของแต่ละสถานะ */}
                {withdrawStatuses?.map((status) => (
                    <li key={status.key} style={stylesFooter.listItem}>
                        <Tag
                            style={stylesFooter.tagStyle}
                            color={tagsBageStatus(status.key)}
                            icon={getIcon(status.key)}
                            className={getTableRowClassName(status.key)}
                        >
                            {t(status.key)}
                        </Tag>
                        <span style={stylesFooter.descText}>
                            : {t(`withdraw_desc.${status.key}`)}
                        </span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export const FooterVerifyslip = ({ t }) => {
    return (<div className="fs-12 fs-sm-11 mb-3" style={stylesFooter.container}>
        <ul style={stylesFooter.listWrapper}>
            <li style={{ marginBottom: 4 }}>
                <strong>{t("note")}</strong>:
            </li>
            <li className="mb-2" style={{ color: "#676666", fontWeight: 'bold', fontSize: 12 }}>
                {t("status_and_description")}
            </li>

            {/* วนลูปเพื่อแสดงผล Tag ของแต่ละสถานะ */}
            {verifyslipStatuses?.map((status) => (
                <li key={status.key} style={stylesFooter.listItem}>
                    <Tag
                        style={stylesFooter.tagStyle}
                        color={tagsBageStatus(status.key)}
                        className={getTableRowClassName(status.key)}
                    >
                        {t(status.key)}
                    </Tag>
                    <span style={stylesFooter.descText}>
                        : {t(`verifyslip_desc.${status.key}`)}
                    </span>
                </li>
            ))}
        </ul>
    </div>)
}

export const FooterCustomer = ({ t }) => {
    return (<div className="fs-12 fs-sm-11 mb-3" style={stylesFooter.container}>
        <ul style={stylesFooter.listWrapper}>
            <li style={{ marginBottom: 4 }}>
                <strong>{t("note")}</strong>:
            </li>
            <li className="mb-2" style={{ color: "#676666", fontWeight: 'bold', fontSize: 12 }}>
                {t("status_and_description")}
            </li>

            {/* วนลูปเพื่อแสดงผล Tag ของแต่ละสถานะ */}
            {CustomerStatuses?.map((status) => (
                <li key={status.key} style={stylesFooter.listItem}>
                    <Tag
                        style={stylesFooter.tagStyle}
                        color={tagsBageStatus(status.key)}
                        icon={getIcon(status.key)}
                        className={getTableRowClassName(status.key)}
                    >
                        {t(status.key)}
                    </Tag>
                    <span style={stylesFooter.descText}>
                        : {t(`customer_desc.${status.key}`)}
                    </span>
                </li>
            ))}
        </ul>
    </div>)
}
